import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useTickets from "./hooks/useTickets";
import LimitedTicketBlock from "./LimitedTicketBlock";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "./style.scss";
import useFacility from "../../../utils/hooks/useFacility";
import EAPageHeader from "../shared/EAPageHeader";
import EAPageMessage from "../shared/EAPageMessage";

const LimitedTicketGroupPage: React.FC = () => {
  const messageGroups = useSelector((state: State) => state.config.configuration.message_groups);
  const facilityIds = useFacility();
  const { assortGroup, requestGetAssortGroups } = useTickets();

  useEffect(() => {
    requestGetAssortGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  return (
    <>
      <div className="container">
        <EAPageHeader componentId="Groups" />
        <EAPageMessage message={messageGroups} />

        {assortGroup && (
          <div className="limited-ticket-wrapper">
            {assortGroup.map((item, index) => (
              <LimitedTicketBlock item={item} sortType="assortGroup" key={index} />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default LimitedTicketGroupPage;
